<template>
  <adminTable
    ref="adminTableRef"
    :tableLoading="tableLoading"
    :totalList="totalList"
    v-model:page="page"
    v-model:limit="limit"
    v-model:searchForm="searchForm"
    :tableData="tableData"
    @search="getList"
  >
    <template v-slot:form-inline-items>
      <el-form-item>
        <el-input v-model="searchForm.title" placeholder="搜索标题" clearable />
      </el-form-item>
    </template>

    <template v-slot:query-button-right>
      <el-button
        type="primary"
        icon="CirclePlus"
        @click="editItem('add', {})"
        v-permission
      >
        添加
      </el-button>
    </template>

    <template v-slot:table>
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="title" label="标题" width="300" />
      <el-table-column prop="code" label="文章编码" width="300" />
      <el-table-column prop="desc" label="描述" width="300" />
      <el-table-column label="内容预览" width="400">
        <template #default="scope">
          <span v-if="!scope.row.content">--</span>
          <span v-else>
            {{ stripHtml(scope.row.content).slice(0, 80) }}
            <span v-if="stripHtml(scope.row.content).length > 80">...</span>
          </span>
        </template>
      </el-table-column>
      <!-- Smart Image Handler - Works with both relative and full URLs -->
      <el-table-column label="图片" width="180">
        <template #default="scope">
          <span v-if="!scope.row.img">--</span>
          <el-image
            v-else
            class="previewImg"
            :preview-teleported="true"
            :src="getImageUrl(scope.row.img)"
            :zoom-rate="1.2"
            :max-scale="7"
            :min-scale="0.2"
            :preview-src-list="[getImageUrl(scope.row.img)]"
            show-progress
            :initial-index="0"
            fit="cover"
            @error="handleImageError"
          >
            <template #error>
              <div class="image-slot">
                <el-icon><Picture /></el-icon>
              </div>
            </template>
          </el-image>
        </template>
      </el-table-column>

      <el-table-column prop="class_name" label="文章类型" width="300" />
      <el-table-column prop="release_time" label="发布时间" width="300" />
      <el-table-column prop="create_at" label="添加时间" width="300" />

      <el-table-column
        label="操作"
        fixed="right"
        width="200"
        v-if="currentUser.role == 0"
      >
        <template #default="scope">
          <el-button
            type="primary"
            icon="Edit"
            v-permission
            @click="editItem('edit', scope.row)"
          >
            编辑
          </el-button>
          <el-button
            type="danger"
            icon="Delete"
            v-permission
            @click="deleteAction(scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </template>

    <el-dialog v-model="dialogFlag" title="编辑/新增" width="1100">
      <editPop
        :key="editRow"
        ref="editFormRef"
        :formType="formType"
        :item="editRow"
      />
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogFlag = false">关闭</el-button>
          <el-button type="primary" @click="submitForm">保存</el-button>
        </div>
      </template>
    </el-dialog>
  </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import { booleanEnums, getLabelByVal } from "@/config/enums";
import EditPop from "./components/newsList/editPop.vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { Picture } from "@element-plus/icons-vue";

const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));

const searchForm = ref({
  title: "",
});
const dialogFlag = ref(false);
const editRow = ref({});
const editFormRef = ref(null);
const adminTableRef = ref(null);
const formType = ref("add");

// 简单的 HTML 标签清理函数，用于内容预览
const stripHtml = (html) => {
  if (!html) return "";
  return html.replace(/<[^>]*>/g, "");
};

const getImageUrl = (img) => {
  if (!img) return "";

  img = img.trim();

  if (img.startsWith("http://") || img.startsWith("https://")) {
    return img;
  }

  if (img.startsWith("//")) {
    return "https:" + img;
  }

  if (img.startsWith("/")) {
    return proxy.IMG_BASE_URL + img;
  } else {
    return proxy.IMG_BASE_URL + "/" + img;
  }

  return proxy.IMG_BASE_URL + img;
};

// 图片加载错误处理函数，避免控制台报错
const handleImageError = (error) => {
  console.warn("Image load failed:", error);
};

onMounted(() => {
  getList();
});

const editItem = (type, row = {}) => {
  debugger;
  formType.value = type;
  editRow.value = row;
  dialogFlag.value = true;
};

const submitForm = async () => {
  const url =
    formType.value == "add" ? "Article/addArticle" : "Article/updateArticle";
  const data = editFormRef.value.form;
  if (formType.value == "add") {
    data.id = null;
  }
  const res = await proxy.$http({
    method: "post",
    url: url,
    data: {
      title: data.title,
      img: data.img,
      class_id: data.class_id,
      code: data.code,
      url: data.url,
      release_time: data.release_time,
      content: data.content,
      desc: data.desc,
      id: data.id,
    },
  });

  if (res.code == 0) {
    dialogFlag.value = false;
    getList();
    ElMessage({
      type: "success",
      message: res.msg,
    });
  } else {
    dialogFlag.value = false;
    ElMessage({
      type: "error",
      message: res.msg,
    });
  }
};

const deleteAction = (row) => {
  ElMessageBox.confirm("是否删除?", "Warning", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(async () => {
      const res = await proxy.$http({
        method: "get",
        url: "Article/deleteArticle?id=" + row.id,
      });
      if (res.code == 0) {
        getList();
      }
      ElMessage({
        type: "success",
        message: res.msg,
      });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消删除",
      });
    });
};

const { proxy } = getCurrentInstance();

const tableData = ref([]);
const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);

const getList = async () => {
  tableLoading.value = true;
  const res = await proxy.$http({
    type: "get",
    url: "/Article/getArticleLists",
    params: {
      page: page.value,
      limit: limit.value,
    },
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data.data;
    totalList.value = res.data.total;
  }
};
</script>

<style lang="less" scoped></style>
